// extracted by mini-css-extract-plugin
module.exports = {"SNA7":"SNA2a_SNA7__1xXA2","KneeContainer":"SNA2a_KneeContainer__1jVE9"};